import VFormTable from './../../components/formTable/formTable.vue';
import Input from './../form/text/text';
import Autocomplete from './../form/autocomplete/autocomplete.vue';
import NumberInput from './../form/number/number';
import FloatInput from './../form/float/float';
import DateInput from './../form/date/date';
import TimeInput from './../form/time/time';
import SelectInput from './../form/select/select';
import DateRangeInput from './../form/dateRange/dateRange';
import PlainText from './../form/plaintext/plaintext';

const components = {
  text: Input,
  email: Input,
  autocomplete: Autocomplete,
  date: DateInput,
  dateRange: DateRangeInput,
  time: TimeInput,
  number: NumberInput,
  select: SelectInput,
  plaintext: PlainText,
  float: FloatInput,
  default: PlainText,
};

export default {
  extends: VFormTable,
  data() {
    return {
      mergeThisProperty: 'Hello',
    };
  },
  props: {
    primaryContactError: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    /**
     * Renders a row from the list to the table.
     *
     * @return {Object} The row template.
     */
    renderTableRow() {
      return this.list.map((item, index) => {
        if (item.id === this.editingItem) {
          return this.renderForm(item);
        }

        const currentItem = item;

        return (
          <tr class="tablerow">
            {Object.keys(this.form.fields).map((field) => {
              if (
                this.hiddenFields.indexOf(field) > -1 ||
                this.isStacked(field)
              ) {
                return null;
              }

              const content = this.renderColumnContent(item, field);

              const stackContent = this.renderColumnContent(
                item,
                this.stack[field]
              );

              // const additionalInfo = this.renderAdditionalInfo(item, field);
              // console.log(additionalInfo);
              const stacked =
                this.stack[field] && item[this.stack[field]] ? (
                  <div class="tableCol--stacked">{stackContent}</div>
                ) : null;

              return (
                <td class="tableCol">
                  <div class="full-w">
                    <span class="tableCol--label">
                      {this.$t(
                        this.translation
                          ? `${this.translation}.${field}.label`
                          : null
                      ) || field}
                      :{' '}
                    </span>
                    {content}
                    {stacked}
                  </div>
                </td>
              );
            })}
            {(this.update || this.destroy) && !this.disableForm ? (
              <td class="tableCol" style="min-width:100px;width:100px;">
                {this.update && !this.disableForm ? (
                  <el-button
                    class="small"
                    onClick={() => this.editItem(item, index)}
                    icon="el-icon-edit"
                  ></el-button>
                ) : null}
                {this.destroy && !this.disableForm && currentItem.type !== 'primary' ? (
                  <el-button
                    class="small"
                    onClick={() => this.removeItem(item)}
                    icon="el-icon-delete"
                  ></el-button>
                ) : null}
              </td>
            ) : null}
          </tr>
        );
      });
    },

    /**
     * Method to render the form row for creating and editing.
     *
     * @return {Object} The form jsx template.
     */
    renderForm(item) {
      if ((!this.create && !this.update) || this.disableForm) {
        return null;
      }

      return (
        <tr class="tablerow">
          {Object.keys(this.form.fields).map((field) => {
            if (this.hiddenFields.indexOf(field) > -1 || this.isStacked(field)) {
              return null;
            }
            const StackedComponent = this.stack[field]
              ? this.renderFormInput(this.stack[field], item)
              : null;

            const stacked = StackedComponent ? (
              <div class="tableCol--stacked">{StackedComponent}</div>
            ) : null;

            return (
              <td class="tableCol">
                {this.renderFormInput(field, item)}
                {stacked}
              </td>
            );
          })}
          < td class = "tableCol" style="min-width:100px" >
            <el-button
              class="small icon-check"
              onClick={this.save}
              icon="el-icon-check"
            ></el-button>
            <el-button
              class="small"
              onClick={this.closeForm}
              icon="el-icon-close"
            ></el-button>
          </td>
        </tr>
      );
    },

    /**
     * Renders the column content.
     *
     * @param  {Object} item  The current item of the list.
     * @param  {String} field The field name.
     * @return {Mixed}       The content to be rendered.
     */
    renderColumnContent(item, field) {
      if (item.type === 'primary' && field === 'contactType') {
        if (this.primaryContactError) {
          return (
            <div>
              { this.$t('form.contactTypes.options.primary') } <br/>
              <span class="text-danger"> { this.$t('form.clients.primaryContactError') } </span>
            </div>
          );
        } else {
          return this.$t('form.contactTypes.options.primary');
        }
      }
      let content = null;
      if (this.form.fields[field] === 'select') {
        const filteredOptions = this.form.options[field].filter((o) => {
          if (typeof item[field] === 'object') {
            return (
              item[field].map(i => (i.id ? i.id : Number(i))).indexOf(o.id) > -1
            );
          }

          return o.id.toString() === item[field].toString();
        });

        if (filteredOptions.length === 1) {
          content = filteredOptions[0].name;
        } else if (filteredOptions.length > 1) {
          content = filteredOptions.map(o => (
            <div class="full-w">
              {o.name}
            </div>
          ));
        } else if (typeof item[field] === 'object') {
          content = item[field].name;
        }
      } else if (this.form.fields[field] === 'autocomplete') {
        const filteredOptions = this.form.options[field].filter((o) => {
          if (typeof item[field] === 'object') {
            // return item[field].map(i => i.id.toString()).indexOf(o.id) > -1;
            return item[field].id.toString() === o.id.toString();
          }

          return o.id.toString() === item[field].toString();
        });

        if (filteredOptions.length === 1) {
          content = filteredOptions[0].name;
        } else if (filteredOptions.length > 1) {
          content = filteredOptions.map(o => (
            <div class="full-w">{o.name}</div>
          ));
        } else if (typeof item[field] === 'object') {
          content = item[field].name;
        } else if (item.name) {
          content = item.name;
        } else {
          content = item[field];
        }
      } else {
        content = item[field];
      }

      const clickHandler = this.clickHandler(item, field);
      if (clickHandler) {
        return (
          <a style="cursor:pointer;" onClick={clickHandler}>
            <span class="fa fa-pencil-square-o"></span>&nbsp; {content}
          </a>
        );
      }

      const tagType = this.tagHandler(item, field);
      if (tagType) {
        return <el-tag type={tagType}>{content}</el-tag>;
      }

      return content;
    },

    /**
     * Render the input component for the column.
     *
     * @param  {String} field The field name.
     * @return {Object}       The component template.
     */
    renderFormInput(field, item) {
      if (item && item.type === 'primary' && field === 'contactType') return this.$t('form.contactTypes.options.primary');

      if (!this.form[field] && this.form.fields[field] === 'plaintext') {
        return null;
      }

      if (this.form[field] == undefined && item && item[field]) {
        return item[field];
      }
      const Component = components[this.form.fields[field]];
      const props = this.form.getExtraAttr(field);
      let value = this.form[field];
      if (this.form.fields[field] === 'autocomplete' && item) {
        value =
          typeof this.form[field] === 'object'
            ? this.form[field].name
            : item.name;
      }

      return (
        <Component
          name={field}
          value={value}
          type={this.form.fields[field]}
          info={this.form.displays[field]}
          controls={false}
          options={this.form.options[field]}
          disabled={this.form.isDisabled(field)}
          onChange={this.onInputChange}
          onKeydown={this.onInputChange}
          translation={`${this.translation}.${field}`}
          {...{ props }}
        />
      );
    },
    // eslint-disable-next-line
    render(h) {
      const createBtn = this.create && !this.disableForm ?
        <el-button class="small" onClick={this.addNewItem}>{this.$t('form.clients.addContact')}</el-button> : null;
      const exportBtn = this.isExport && !this.disableForm ?
        <el-button class="small" onClick={this.exportClickHandler}>{this.$t('button.export')}</el-button> : null;
      const table = this.list.length || this.addingItem ? this.renderTable() : null;
      const message = !this.list.length && !this.addingItem ?
        <v-message warning={this.$t('form.clients.noContactWarning')} /> : null;
      const fileUploader = this.isImport && !this.disableForm ? <file-pond name="import_excel" ref="pond" label-idle={this.$t('button.dragAndDropImport')} allow-multiple="false" server={this.server} /> : null;
      return <div class="form-table--parent">
        <el-row>
            <el-col class="el-col el-col-24 el-col-xs-24 el-col-sm-24 el-col-md-4 el-col-lg-4">
              { createBtn }
              { exportBtn }
            </el-col>

            <el-col class="el-col el-col-24 el-col-xs-24 el-col-sm-24 el-col-md-18 el-col-lg-18">
            { fileUploader }
            </el-col>
            <el-col>
              { table }
            </el-col>
        </el-row>
        { message }
      </div>;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/components/clientContactFormTable/clientContactFormTable.js